import getArticleField from './getArticleField';

const getQueryField = (prefix: string, hasLocalNews: boolean) => `${
  getArticleField(prefix, hasLocalNews, false)}s`;

export default getQueryField;
